import * as Sentry from '@sentry/node';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';

import { apiErrorToPageError } from '../../service/helpers';
import { setPageError, setRecaptchaToken } from './actions';

export const handleApiError =
  (err: Error): ThunkAction<void, null, null, Action> =>
  async (dispatch) => {
    dispatch(setPageError(apiErrorToPageError(err)));
    Sentry.captureException(err);
  };

export const triggerRecaptcha =
  (context: { executeAsync: () => Promise<string> }): ThunkAction<Promise<void>, null, null, Action> =>
  async (dispatch) => {
    const recaptchaToken = await context.executeAsync();
    dispatch(setRecaptchaToken(recaptchaToken));
  };
